// extracted by mini-css-extract-plugin
export default {"ChartContainer":"barChart_ChartContainer__xYxM-","Chart":"barChart_Chart__LJ5DM"};